import { render, staticRenderFns } from "./closed.vue?vue&type=template&id=20e7c2ac&scoped=true"
import script from "./closed.vue?vue&type=script&lang=js"
export * from "./closed.vue?vue&type=script&lang=js"
import style0 from "./closed.vue?vue&type=style&index=0&id=20e7c2ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e7c2ac",
  null
  
)

export default component.exports